import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

export const QUERY_MANAGEMENT_GET_UNIT_TASK_GROUP = (id: number) => ['getUnitTaskGroup', id]

export const getUnitTaskGroup = async (id: number): Promise<IUnitTaskGroupModel> =>
  axios.get(`/management/UnitProgramTask/GetTaskGroup?id=${id}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitTaskGroup

type Props = {
  config?: QueryConfig<QueryFnType>
  id: number
}

export const useManagementGetUnitTaskGroup = ({ config, id }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_MANAGEMENT_GET_UNIT_TASK_GROUP(id),
    queryFn: () => getUnitTaskGroup(id)
  })
